import placeholderImage from '../../../Images/logo.svg';
import Button from '../../../Framework/Components/Buttons/Button';
import { ButtonSize } from '../../../Framework/Data/Enums/Generic';
import DropdownMenu from '../../../Framework/Components/DropdownMenus/DropdownMenu';
import ItemMenuEntry from '../../../Framework/Components/Navigation/ItemMenuEntry';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen, faRectangleHistory } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { useUKPBAuth } from '../../../Providers/AuthProvider';
import { useUser } from '../../../Api/UsersEndpoints';
import { NavLink } from 'react-router-dom';
import { useLayout } from '../../../Framework/Providers/LayoutProvider';
import { ColourMod } from '../../../Framework/Data/Enums/LayoutEnums';

const UserPageHeader = () => {
	const { LogOut } = useUKPBAuth();
	const { data } = useUser();
	const { isMedium, isLarge, isXL } = useLayout();

	return (
		<div className={`row ${!isMedium ? 'p-sm' : ''} ${isXL ? 'mt-sm mb-lg' : ''} raised-header`}>
			<div className={'col-xs-12 col-center-md-8 col-center-lg-10 col-center-xxl-8'}>
				<div className='row'>
					<div className='col-xs-12'>
						<div className={`row ${isMedium ? 'mt-md pl-lg pr-lg ' : ''}`}>
							<div className='col-xs-6'>
								<NavLink to={'/sends-page'}>
									<img
										src={placeholderImage}
										alt={'UK Postbox Logo'}
										style={{ minWidth: '12em', height: '2em' }}
									/>
								</NavLink>
							</div>
							<div className='col-xs-6 text-right'>
								<Button
									title={data?.name as string}
									colour={ColourMod.Text}
									size={ButtonSize.Small}
									extraClass={'send-user-menu'}
									showArrow={true}
								/>
								<DropdownMenu target={['send-user-menu']}>
									<ItemMenuEntry
										title={'History'}
										url={'../sends-page/history'}
										icon={<FontAwesomeIcon icon={faRectangleHistory} fixedWidth={true} />}
									/>
									{!data?.roles.includes('SENDS_PAGE_ADMIN') && !data?.roles.includes('MANAGER') && (
										<>
											<ItemMenuEntry title={'Divider'} sectionDivider={true} />
											<ItemMenuEntry
												title={'Logout'}
												callback={() => LogOut()}
												icon={<FontAwesomeIcon icon={faDoorOpen} fixedWidth={true} />}
											/>
										</>
									)}
								</DropdownMenu>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserPageHeader;
